import jwt_decode from "jwt-decode";

import {
  ACCESS_TOKEN_KEY,
  EXPIRES_AT_KEY,
  ORGANIZATION_KEY,
} from "@shared/constants";
import { UserData } from "@shared/types";
import { recoverBrowserSecurityError } from "@shared/utils";

import { refreshIdentity } from "./refreshIdentity";

export const refreshUserAuth = async (
  setUser: (user: UserData) => void
): Promise<void> => {
  // post code to backend and do auth there;
  const { token } = await refreshIdentity();

  // save bearer token from backend to localStorage
  // nosemgrep
  const decoded = jwt_decode<any>(token);
  recoverBrowserSecurityError(() => {
    // make sure to invalidate cache first
    // nosemgrep
    localStorage.removeItem(ORGANIZATION_KEY);
    // then replace with new login token
    // nosemgrep
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    // nosemgrep
    localStorage.setItem(EXPIRES_AT_KEY, JSON.stringify(decoded.exp * 1000));

    // Update user in UserContext
    if (setUser) {
      // nosemgrep
      const { identity } = jwt_decode<any>(token);
      setUser(identity);
    }
  });
};
